import React from 'react'
import PropTypes from 'prop-types'

export const MoreIcon = ({ width = 24, height = 24, fill = '#000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M11 5.33649V16.5486"
        stroke={fill}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.6008 10.9373H5.39917"
        stroke={fill}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

MoreIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}
